import { forwardRef, HTMLAttributes, memo } from "react";
import classnames from "classnames";
import { IconComplete } from "./icon";

import styles from "./style.module.scss";

export type StepIconBaseSize = "sm" | "md" | "lg";

export type StepIconBaseStatus =
  | "current"
  | "complete"
  | "incomplete";


export type ProgressStepBasePointProps = {
  size?: StepIconBaseSize;
  status?: StepIconBaseStatus;
} & HTMLAttributes<HTMLDivElement>;

export const StepIconBase = memo(
  forwardRef<HTMLDivElement, ProgressStepBasePointProps>(
    (
      {
        size = "lg",
        className,
        status = "incomplete",
        ...pointProps
      },
      ref
    ) => {
      return (
        <div
          className={classnames(
            className,
            styles.rootPoint,
            styles[status as keyof typeof styles],
            styles[size as keyof typeof styles]
          )}
          {...pointProps}
          ref={ref}
        >
          {status === "complete" && <IconComplete />}
        </div>
      );
    }
  )
);